import React, { Fragment } from 'react';
import { bool, string, array, oneOfType, number } from 'prop-types';
import { map } from 'lodash';
import { Text, FlexContainer, Row, Divider, Icon, CounterButton } from '../../common';
import { Link } from 'react-router-dom';

const StatusField = ({ label, value, selectedSla, status, salesChannel, isTotal, backgroundColorOnHover, dateRange, selectedSalesChannels }) => {
    const leftColumWidth = '44px';
    return (
        <Row padding='5px 0' align='center'>
            <div style={{ width: `calc(100% - ${leftColumWidth})` }}>
                <Text text={label} strong={isTotal} />
            </div>
            <Link target='_blank'
                to={{
                    pathname: '/orders',
                    search: `selectedSla=${selectedSla || ''}&status=${status || ''}&salesChannel=${(salesChannel || map(selectedSalesChannels, 'value')) || ''}&range=${dateRange || ''}`
                }}>
                <CounterButton
                    style={{ width: leftColumWidth }}
                    backgroundColorOnHover={backgroundColorOnHover}
                >
                    <Text text={value} strong={isTotal} />
                </CounterButton>
            </Link>
        </Row>
    );
};

StatusField.propTypes = {
    label: string,
    value: string,
    isTotal: bool,
    backgroundColorOnHover: string,
    selectedSla: array,
    salesChannel: oneOfType([string, () => undefined]),
    status: string,
    dateRange: array,
    selectedSalesChannels: array
};

StatusField.defaultProps = {
    label: '',
    value: 0,
    isTotal: false
};

const SlaCard = ({
    width,
    selectedSla,
    status,
    icon,
    name,
    salesChannel,
    label,
    color,
    pendientePicking,
    inPicking,
    pendienteAuditoria,
    pendienteFacturacion,
    errorFacturar,
    facturado,
    anulado,
    total,
    dateRange,
    selectedSalesChannels
}) => {
    const items = [
        { label: 'Pendiente picking', count: `${pendientePicking}`, status: ['1', '2', '7', '20', '22'].join('-') },
        { label: 'En picking', count: `${inPicking}`, status: ['3', '6'].join('-') },
        { label: 'Pendiente auditoría', count: `${pendienteAuditoria}`, status: ['30', '32'].join('-') },
        { label: 'Pickeado por facturar', count: `${pendienteFacturacion}`, status: ['4', '8'].join('-') },
        { label: 'Error facturar', count: `${errorFacturar}`, status: ['9'] },
        { label: 'Facturado', count: `${facturado}`, status: ['5', '50', '51', '53', '54', '55', '56', '57', '58', '59', '60'].join('-') },
        { label: 'Anulado', count: `${anulado}`, status: ['41'].join('-') }
    ];
    const totals = [
        { label: 'Total', count: `${total}` }
    ];

    return (
        <FlexContainer
            direction='column'
            grow={1}
            padding={15}
            backgroundColor='#ffffff'
            width={width}
            borderRadius={3}
            style={{
                backgroundColor: '#ffffff',
                width,
                borderRadius: '3px',
                padding: '15px',
                boxSizing: 'border-box',
                boxShadow: 'rgb(0 0 0 / 20%) 3px 0px 0px -4px, rgb(0 0 0 / 6%) 0px 1px 0px 0px, rgb(0 0 0 / 6%) 1px 0px 0px 0px'
            }}
        >
            <Row align='center'>
                { color && (name !== 'resume') && (
                    <FlexContainer
                        width={32}
                        height={32}
                        borderRadius={4}
                        backgroundColor={color}
                        align='center'
                        justify='center'
                        mR={7}
                    >
                        <Icon name={icon || name} color='#ffffff' size={23} />
                    </FlexContainer>
                )}
                {/* Card title */}
                <Link target='_blank'
                    to={{
                        pathname: '/orders',
                        search: `selectedSla=${selectedSla || ''}&status=${status || ''}&salesChannel=${(salesChannel || map(selectedSalesChannels, 'value')) || ''}&range=${dateRange || ''}`
                    }}
                >
                    <Text text={label} cursor='pointer' underlineOnHover strong />
                </Link>
            </Row>
            <Divider style={{ margin: 3 }} />
            {/* Card body */}
            { map(items, ({ label, count, status }, index) => (
                <Fragment key={index}>
                    <StatusField
                        label={label}
                        value={count}
                        status={status}
                        selectedSla={selectedSla}
                        salesChannel={salesChannel}
                        dateRange={dateRange}
                        selectedSalesChannels={selectedSalesChannels} />
                    <Divider style={{ margin: 3 }} />
                </Fragment>
            )) }
            {/* Card totals */}
            { map(totals, ({ label, count }, index) => <StatusField
                key={index}
                label={label}
                isTotal
                value={count}
                backgroundColorOnHover='#1fa02e'
                selectedSla={selectedSla}
                salesChannel={salesChannel}
                dateRange={dateRange}
                status={status}
                selectedSalesChannels={selectedSalesChannels}
            />) }
        </FlexContainer>
    );
};

SlaCard.propTypes = {
    width: string,
    label: string,
    selectedSla: array,
    status: string,
    name: string,
    icon: string,
    salesChannel: string,
    color: string,
    pendientePicking: number,
    inPicking: number,
    pendienteAuditoria: number,
    pendienteFacturacion: number,
    facturado: number,
    anulado: number,
    total: number,
    dateRange: array,
    selectedSalesChannels: array
};

export default SlaCard;
